// Import Actions
import { SET_SESSIONS, SET_SESSION_SUBJECT_DATA, ADD_ACTIVE_PROCTOR, REMOVE_ACTIVE_PROCTOR, REMOVE_SESSION } from './SessionActions';
import { SET_SESSION_APPLICANTS, UPDATE_APPLICANT_KEY, SET_LAST_PROCTORING_ACTIVITY, SET_APPLICANTS } from '../Applicant/ApplicantActions';
import { SET_APPLICANT_ANSWERS } from '../Answer/AnswerActions';
import { LOGOUT_USER } from '../User/AuthActions';
import { SET_IS_FETCHING } from '../App/AppActions';

// Initial State
export const initialState = {
    data: [],
    isFetching: false,
};

// Think to update reducers.js

const SessionReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_SESSIONS:
            return {
                ...state,
                data: action.isSet ? action.sessions : [
                    ...state.data.filter(existingSession => !action.sessions.find(session => session._id === existingSession._id)), // Keep existing sessions not in new sessions
                    ...action.sessions.map(session => {
                        const existingSession = state.data.find(existingSession => session._id === existingSession._id);
                        if(existingSession) { // Update existing session with request results
                            return {
                                ...existingSession,
                                ...session,
                            };
                        }
                        return session;
                    }),
                ].map(session => {
                    const existingSession = state.data.find(existingSession => existingSession._id === session._id);
                    if(existingSession && existingSession.applicants) {
                        return {
                            ...session,
                            applicants: existingSession.applicants, // Keep applicants list set in other action
                        };
                    }
                    return session;
                }),
                isFetching: false,
            };

        case SET_SESSION_SUBJECT_DATA:
            return {
                ...state,
                data: state.data.map(session => {
                    if(session._id === action.sessionId) {
                        return {
                            ...session,
                            subjectData: action.subjectData,
                        };
                    }
                    return session;
                }),
            };

        case SET_SESSION_APPLICANTS:
        case SET_APPLICANTS:
            return {
                ...state,
                data: state.data.map(session => {
                    if(session._id === (action.sessionId || action.applicants[0]?.session?._id || action.applicants[0]?.session)) {
                        return {
                            ...session,
                            applicants: (
                                action.isSet
                                ? action.applicants
                                : (session.applicants || []).filter(existingApplicant => !action.applicants.find(newApplicant => newApplicant._id === existingApplicant._id)).concat(action.applicants)
                                ).map(applicant => {
                                    const existingApplicant = (session.applicants || []).find(existingApplicant => existingApplicant._id === applicant._id);
                                    return {
                                        ...applicant,
                                        answers: (existingApplicant && existingApplicant.answers) || [],
                                        lastProctoringActivity: (existingApplicant && existingApplicant.lastProctoringActivity) || false,
                                    };
                                }),
                        };
                    }
                    return session;
                }),
            };

        case SET_APPLICANT_ANSWERS:
            return {
                ...state,
                data: state.data.map(session => {
                    return {
                        ...session,
                        applicants: (session.applicants || []).map(applicant => {
                            if(applicant._id === action.applicantId) {
                                return {
                                    ...applicant,
                                    answers: (applicant.answers || []).filter(existingAnswer => !action.answers.find(answer => answer.question === existingAnswer.question)).concat(action.answers.filter(answer => answer.applicant === action.applicantId)),
                                };
                            }
                            return applicant;
                        }),
                    };
                }),
            };

        case UPDATE_APPLICANT_KEY:
            if(action.sessionId) {
                return {
                    ...state,
                    data: state.data.map(session => {
                        if(session._id === action.sessionId) {
                            return {
                                ...session,
                                applicants: (session.applicants || []).map(applicant => {
                                    if(applicant._id === action.applicantId) {
                                        return {
                                            ...applicant,
                                            [action.key]: action.value,
                                        };
                                    }
                                    return applicant;
                                }),
                            };
                        }
                        return session;
                    }),
                };
            }
            return state;

        case SET_LAST_PROCTORING_ACTIVITY:
            if(action.sessionId && action.applicantId) {
                return {
                    ...state,
                    data: state.data.map(session => {
                        if(session._id === action.sessionId) {
                            return {
                                ...session,
                                applicants: (session.applicants || []).map(applicant => {
                                    if(applicant._id === action.applicantId) {
                                        return {
                                            ...applicant,
                                            lastProctoringActivity: action.timestamp,
                                        };
                                    }
                                    return applicant;
                                }),
                            };
                        }
                        return session;
                    }),
                };
            }
            return state;

        case ADD_ACTIVE_PROCTOR:
            if(action.sessionId && action.proctorId) {
                return {
                    ...state,
                    data: state.data.map(session => {
                        if(session._id === action.sessionId) {
                            return {
                                ...session,
                                activeProctors: [
                                    ...(session.activeProctors || []).filter(proctorId => proctorId !== action.proctorId),
                                    action.proctorId,
                                ],
                                proctorActivityIndex: (session.proctorActivityIndex || 0) + 1,
                            };
                        }
                        return session;
                    }),
                };
            }
            return state;

        case REMOVE_ACTIVE_PROCTOR:
            if(action.sessionId && action.proctorId) {
                return {
                    ...state,
                    data: state.data.map(session => {
                        if(session._id === action.sessionId) {
                            return {
                                ...session,
                                activeProctors: (session.activeProctors || []).filter(proctorId => proctorId !== action.proctorId),
                            };
                        }
                        return session;
                    }),
                };
            }
            return state;

        case REMOVE_SESSION:
            return {
                ...state,
                sessions: state.data.filter(session => session._id !== action.sessionId),
            };

        case SET_IS_FETCHING:
            if(action.dataType === 'sessions') {
                return {
                    ...state,
                    isFetching: action.isFetching,
                };
            }
            return state;

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};

export default SessionReducer;
